"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withNativeProps = withNativeProps;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function withNativeProps(props, element) {
  var p = _objectSpread({}, element.props);

  if (props.className) {
    p.className = (0, _classnames["default"])(element.props.className, props.className);
  }

  if (props.style) {
    p.style = _objectSpread(_objectSpread({}, p.style), props.style);
  }

  for (var key in props) {
    // eslint-disable-next-line
    if (!props.hasOwnProperty(key)) continue;

    if (key.startsWith("data-") || key.startsWith("aria-")) {
      p[key] = props[key];
    }
  }

  return /*#__PURE__*/_react["default"].cloneElement(element, p);
}